
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { reverse, forEach } from 'lodash';
import MobileLineItem from './MobileLineItem';
import { products } from '../../services';
import Loading from '../Loding/Loading';
import { NoService } from '.';

class Internet extends Component {
  componentDidMount() {
    const {
      setProducts,
      setMobileProducts,
      setMobileProductsForSearch,
      setFixeProducts,
      setInternetProducts,
      setTvProducts,
      setBundlesProducts,
    } = this.props;
    products.getProducts()
    .then((res) => {
      if (res) {
        if (res) {

          let mobileProducts= []
          let fixeProducts = []
          let internetProducts = []
          let tvProducts = []
          let bundlesProducts = []
          setProducts(res.body.data.userProducts);
          forEach(res.body.data.userProducts,(product) => {
            reverse(product.Options)
            if (product.Data.category === 'MOBILE') {
              mobileProducts.push(product)
            } else if (product.Data.category === 'FIXE'){
              fixeProducts.push(product)
            } else if (product.Data.category === 'INTERNET'){
              internetProducts.push(product)
            } else if (product.Data.category === 'TV'){
              tvProducts.push(product)
            } else if (product.Data.category === 'BUNDLES'){
              bundlesProducts.push(product)
            }
          })
          setMobileProducts(mobileProducts);
          setMobileProductsForSearch(mobileProducts);
          setFixeProducts(fixeProducts)
          setInternetProducts(internetProducts);
          setTvProducts(tvProducts);
          setBundlesProducts(bundlesProducts);
          this.props.loadServices();

        }
      }
    });
  }
  render() {

    const { translate, internetProducts, isLoaded} = this.props;
    let activeInternetItems = [];
    let inactiveInternetItems = [];
    forEach(internetProducts,(product) => {
      if (product.Data.isActive ) {
        activeInternetItems.push(
          <MobileLineItem
              Data={product.Data}
              bundleName={product.Data.bundleName}
              isInBundle={product.Data.isInBundle}
              isFrozen={product.Data.isFrozen}
              hasFutureFreeze={product.Data.hasFutureFreeze}
              isActive={product.Data.isActive}
              userProductId={product.Data.userProductId}
              offer={product.Data.offer}
              title={product.Data.offer}
              subscription1={translate('installation-address')}
              subtitle1={product.Data.dataAddress}
              createdDate={product.Data.createdDate}
              simNumber={product.Data.simNumber}
              provider={product.Data.provider}
              options={product.Options}
              key={product.Data.userProductId}
              hasFutureMispari={product.Data.hasFutureMispari}
              hasMispariActive={product.Data.hasMispariActive}
              showOptions={product.Data.showOptions}
            />
        )
      } else if (!product.Data.isActive && !product.Data.cantBeDisplayInInactiveLines) {
        inactiveInternetItems.push(
          <MobileLineItem
             Data={product.Data}
             bundleName={product.Data.bundleName}
             isInBundle={product.Data.isInBundle}
             isFrozen={product.Data.isFrozen}
             hasFutureFreeze={product.Data.hasFutureFreeze}
             isActive={product.Data.isActive}
             userProductId={product.Data.userProductId}
             offer={product.Data.offer}
             title={product.Data.offer}
             subscription1={translate('installation-address')}
             subtitle1={product.Data.dataAddress}
             createdDate={product.Data.createdDate}
             simNumber={product.Data.simNumber}
             provider={product.Data.provider}
             options={product.Options}
             key={product.Data.userProductId}
             hasFutureMispari={product.Data.hasFutureMispari}
             hasMispariActive={product.Data.hasMispariActive}
             showOptions={product.Data.showOptions}
           />
          )
        }
      })
     const inactiveItemsInternet = inactiveInternetItems[0] ?
     <div>
       <h3 className="service-section-title">
         <span>inactives</span>
         <i className="material-icons ng-binding collapsed" data-toggle="collapse" data-target="#inactive" aria-expanded="false" >
           keyboard_arrow_down
         </i>
       </h3>
       <div id="inactive" className="collapse">
         { inactiveInternetItems }
       </div>
     </div>
      : '';
   return (
     <div className="service">
         <h1 className="title">{translate('internet')}</h1>
        <div className="form-group">
         </div>
       { isLoaded ? activeInternetItems[0] ? activeInternetItems : NoService(translate) : Loading()}
       { inactiveItemsInternet }
     </div>
     );
   }
}


const viewMapStateToProps = (state) => {
  return {
    products: state.Products.products,
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    internetProducts: state.Products.internetProducts,
    isLoaded: state.User.isLoaded,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setProducts: (products) => {
      dispatch(
        {
          type: 'SET_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProducts: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProductsForSearch: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS_FOR_SEARCH',
          products: products,
        },
      );
    },
    setFixeProducts: (products) => {
      dispatch(
        {
          type: 'SET_FIXE_PRODUCTS',
          products: products,
        },
      );
    },
    setInternetProducts: (products) => {
      dispatch(
        {
          type: 'SET_INTERNET_PRODUCTS',
          products: products,
        },
      );
    },
    setBundlesProducts: (products) => {
      dispatch(
        {
          type: 'SET_BUNDLES_PRODUCTS',
          products: products,
        },
      );
    },
    setTvProducts: (products) => {
      dispatch(
        {
          type: 'SET_TV_PRODUCTS',
          products: products,
        },
      );
    },
    loadServices: () => {
      dispatch({
        type: 'LOAD_SERVICES_INFO',
        isLoaded: true,
      });
    },
  }
}

Internet = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(Internet);

export default Internet;



// WEBPACK FOOTER //
// ./src/components/MyServices/Internet.js